import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => ({
    productWidgetContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
      textAlign: 'center',
      margin: theme.spacing(0.5, 0),
      maxWidth: 'none',
      padding: theme.spacing(0, 0.5),
    },
    productTitleSection: {
      minHeight: theme.spacing(11),
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      marginBottom: theme.spacing(0.5),
    },
    productProceedsSection: {
      minHeight: theme.spacing(10),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    productLegendRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      height: theme.spacing(8),
      minHeight: theme.spacing(8),
      // Match the pie chart width so legend stays centered under the chart
      width: 180,
      margin: '0 auto',
      textAlign: 'left',
    },
    productLegendItem: {
      margin: 0,
      padding: 0,
      width: '100%',
      flex: '1 1 auto',
      '& .MuiBox-root': {
        marginLeft: '0 !important',
        marginRight: '0 !important',
      },
    },
    productLegendTitleContainer: {
      width: '100%',
    },
    productPieChartTitle: {
      margin: 0,
      marginLeft: theme.spacing(1),
      fontSize: theme.typography.body2.fontSize,
      lineHeight: 1.3,
      textAlign: 'left',
    },
    productPieChartText: {
      textAlign: 'left',
      marginLeft: theme.spacing(3),
    },
    smPieChartWidgetContainer: {
      width: 180,
      height: 180,
      margin: theme.spacing(0.5, 'auto'),
      flexShrink: 0,
    },
  }),
  {index: 1},
);

export default useStyles;
